<template>
  <div style="width: 500px; height: 300px" :id="id" :class="className"></div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  props: {
    className: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  methods: {
    initChart() {
      const chartDom = document.getElementById(this.id);
      this.chart = echarts.init(chartDom);
      this.setOptions(this.chartData);
    },
    setOptions(data) {
      this.chart.setOption({
        title: {
          text: data.totalSize,
          textStyle: {
            fontSize: 23
          },
          subtext: '听课节数\n\n',
          subtextStyle: {
            fontSize: 14
          },
          left: 'center',
          top: 'center'
        },
        series: [
          {
            hoverAnimation: false,
            type: 'pie',
            radius: ['80%', '100%'],
            label: {
              show: false
            },
            data: data.data
          }
        ]
      });
    }
  }
};
</script>
